module.exports = __webpack_public_path__ + "img/full2-min.45af14e9.png";